import ReactDOM from 'react-dom/client';
import './index.css';
import "@fontsource/lexend/variable.css";
import 'material-icons/iconfont/material-icons.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render( <App /> );
